import Menu from "../../../components/Menu"
import RoundyContainer from 'components/RoundyContainer'
import { AddVehicleContextComp, AddVehicleContext } from 'components/StraightThroughVehicleComp/AddVehicleContext/AddVehicleContext'
import EndorsementSummaryMain from 'components/StraightThroughVehicleComp/VehicleMain_Add/EndorsementSummaryMain'
import React, { useEffect, useContext } from 'react'
import { useNavigate } from "react-router-dom"
import { storageData } from "services/Services"

const EndorsementSummary = (props) => {
    const navigate = useNavigate();
    const { userData } = props.user
    const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

    useEffect(() => {
        window.scrollTo(0, 0)

        // Redirect to maintenance page if maintenance is on for Add Vehicle Endorsement
        if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementAddVehicle")) {
            navigate("/maintenance")
            return
        }
    }, [])

    return (
        <>
            <AddVehicleContextComp>
                <Menu Title={"ADD VEHICLE"} FirstName={userData.firstName} userData={userData} />
                <RoundyContainer Content={EndorsementSummaryMain} NoRoundy
                    params={{
                        storedData: { ...props.storedData },
                        setStoredData: props.setStoredData
                    }}
                />
            </AddVehicleContextComp>
        </>
    )
}

export default EndorsementSummary